import { InputNumber, Popover } from 'antd'
import { Decimal } from 'decimal.js'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { deepCopy } from '../../../tools/arrayObject'
import { Utils, toCutNum, getValueFromJsonStr} from '../../../tools/utils'
import { CompanyLevelIdType } from '../../companymanager/salesmanManager_v2/detail/salesman.function'
import { TableContext } from './contextManager'
import './tablesTemplateNew.less?v=12312312'
import { useParams } from 'react-router-dom'
/**
 *
 * 推广费模板详情，table相关组件
 * 表头，表体，表格组件
 */
const hideFreeSpuIds = ['1587635517221134336', '1587793946612932608', '1587794860139462656', '1793535007039152128', '1894031285585797120', '1906708872199659520', '1930832246809726976', '1935993185306927104', '1954823820553216000', '1959877539758071808', '1960246467213299712', '1961311498289975296', '1961319537160130560', '1961322418412097536', '1963498363176783872', '1963529062316761088', '1968592132268003328']

/** ===========================================================================
 * 自适应表头 （影响因子、缴费年期）
 * @param props
 * @returns {*}
 * @constructor
 */
export const TableHeaderFlex = props => {
  const hasActive =  props.hasActive || false; // 活动
  const {pathname} = useLocation()

  const PopconfirmTitle = ()=> {
    let isCompanyLevel = JSON.parse(sessionStorage.getItem('userData')).companyLevelId;
    if(isCompanyLevel === CompanyLevelIdType.总部){
      return <div className='popconfirm-title'>
        <p>您可以从首年剩余中挪出推广费在续期成功</p>
        <p>时进行发放，以激励业务员推动客户续期</p>
        <p><span>第二年奖励=第二年奖励费率X首年保费</span></p>
        <p><span>发放时间：同第二年费用一同发放</span></p>
      </div>
    }
    return <div className='popconfirm-title'>
      <p><span>第二年奖励=第二年奖励费率X首年保费</span></p>
      <p><span>发放时间：同第二年费用一同发放</span></p>
    </div>
  }
  const PopconfirmTitle2 = ()=> {
    return <div className='popconfirm-title'>
      <p>首年后置费用：指基于风险管理角度</p>
      <p>把首年推广费后置缓发的一部分推广费用，</p>
      <p>该比例对应的保费基数是指首年保费，</p>
      <p> 结算时间同等二年续期推广费结算时间。</p>
    </div>
  }
  const PopconfirmTitle3 = ()=> {
    return <div className='popconfirm-title'>
      <p>第六年+：指当保单缴费年期>5年交时，</p>
      <p> 自第6年起至缴费年期结束，每年续期推广费</p>
      <p> 的费率都以第6+的费率进行计算。</p>
    </div>
  }
//是不是模板页面
  const isTemplate =  pathname.startsWith('/feeTemplate/detail');
  const isProductPage =  pathname.startsWith('/productRepository/detail');//是不是产品详情页
const {json} = useParams()
const jsonstr = decodeURIComponent(json)
const spuId = getValueFromJsonStr(jsonstr, 'spuId')
console.log(spuId);
console.log('isTemplate是魔板页面吗', props)
  return (
    <div className="tree-table" style={{borderBottom: 'none'}}>
      <div className="th factor-col">
        影响因子
        <Popover
            placement="bottomLeft"
            title="影响因子"
            content={'影响因子：指影响推广费费率的因素'}
            arrowPointAtCenter
        >
            <div className='mark' style={{'color': '#FF7736'}}>?</div>
        </Popover>
      </div>
      <div className="tree-table">
        <div className="th payperiod-col">缴费年期</div>
        <div className="tree-table">
          { // 产品库的详情-不展示此列
            !props.isFromRepository &&
            <div className="th assign-col">推广费分配(%)</div>
          }
          <div className="th fee-td">首年</div>
          {
            hasActive &&
            <div className="th fee-td active-theader" style={{minWidth:'100px'}}>
              { // 当前登陆账户是商户(顶级机构) 且 是在产品库详情页
                (Utils.isCommercial() && props.isFromRepository)  ?'首年活动':'业务员首年活动'
              }
            </div>
          }
          {(String(props.productType) !== '2000'||isTemplate)&&<div className="th fee-td">
           首年后置费用
           <Popover
                placement="bottomLeft"
                title="首年后置费用"
                content={<PopconfirmTitle2/>}
                arrowPointAtCenter
            >
            <div className='mark' style={{'color': '#FF7736'}}>?</div>
        </Popover>

            </div>}
          <div className="th fee-td">{hideFreeSpuIds.includes(spuId)? '续保': '第二年'}</div>
          {
            !props.isShortInsClass &&
            <React.Fragment>
              {/* 不是产品库详情页  不是短险 展示第二年奖励列 */}
              { (!pathname.startsWith('/productRepository/detail') && String(props.productType) !== '2000') && <div className="th fee-td" style={{minWidth: '100px'}}>
                <div>第二年奖励</div>
                {
                    props.productState !==2 &&  <Popover
                    placement="bottomLeft"
                    title="第二年奖励"
                    content={<PopconfirmTitle />}
                    arrowPointAtCenter
                  >
                    <div className='mark' style={{'color': '#FF7736'}}>?</div>
                  </Popover>
                }

              </div>
              }
                {!hideFreeSpuIds.includes(spuId) && <div className="th fee-td">第三年</div>}
                {!hideFreeSpuIds.includes(spuId) && <div className="th fee-td">第四年</div>}
                {!hideFreeSpuIds.includes(spuId) && <div className="th fee-td">第五年</div>}
                {!hideFreeSpuIds.includes(spuId) && <div className="th fee-td">第六年</div>}
                {!hideFreeSpuIds.includes(spuId) && <div className="th fee-td">第七年</div>}
                {!hideFreeSpuIds.includes(spuId) && <div className="th fee-td">第八年</div>}
                {!hideFreeSpuIds.includes(spuId) && <div className="th fee-td">第九年</div>}
                {!hideFreeSpuIds.includes(spuId) && <div className="th fee-td">第十年</div>}
                {!hideFreeSpuIds.includes(spuId) && <div className="th fee-td">第十一年</div>}
                {!hideFreeSpuIds.includes(spuId) && <div className="th fee-td">第十二年</div>}
                {!hideFreeSpuIds.includes(spuId) && <div className="th fee-td">第十三年</div>}
                {!hideFreeSpuIds.includes(spuId) && <div className="th fee-td">第十四年</div>}
                {!hideFreeSpuIds.includes(spuId) && <div className="th fee-td">第十五年</div>}
                {!hideFreeSpuIds.includes(spuId) && <div className="th fee-td">第十六年</div>}
                {!hideFreeSpuIds.includes(spuId) && <div className="th fee-td">第十七年</div>}
                {!hideFreeSpuIds.includes(spuId) && <div className="th fee-td">第十八年</div>}
                {!hideFreeSpuIds.includes(spuId) && <div className="th fee-td">第十九年</div>}
                {!hideFreeSpuIds.includes(spuId) && <div className="th fee-td">第二十年</div>}
              {/* {(String(props.productType) !== '2000'||isTemplate)&& !hideFreeSpuIds.includes(spuId)&&<div className="th fee-td">
               第六年+
                <Popover
                  placement="bottomLeft"
                  title="第六年+"
                  content={<PopconfirmTitle3 />}
                  arrowPointAtCenter
                >
                  <div className='mark' style={{'color': '#FF7736'}}>?</div>
                </Popover>
                </div>} */}
            </React.Fragment>
          }
        </div>
      </div>
    </div>
  )
}

/** ============================================================================
 * 单条-影响因子table（影响因子、缴费年期、推广费分配、首年、第二年。。）
 * @param props
 * @returns {*}
 */
export const FactorTable = props => {
  const {rateInfos} = props.data // 改：rateValues ==> rateInfos
  // payperiodVal 单行的缴费数据
  const onChangePayperiod = (key, payperiodVal) => {
    const _data = [...rateInfos]
    _data[key] = payperiodVal
    props.changeFactor(props.spuCollectionsKey, props.factorKey, _data)
  }
  return (
    <div className="tree-table">
      <div className="factor-col" style={{display:'block'}} dangerouslySetInnerHTML={{ __html: props.data.rateCodeGroupingDesc ? props.data.rateCodeGroupingDesc.replace('【','<span style="color:red">').replace('】','</span>'):'-' }}/>
      <div className="branch-box">
        {
          rateInfos.length && rateInfos.map((factorData, index) => {
            return <PayperiodTable key={index}
                                  isTop={props.isTop}
                                   payperiodKey={index}
                                   onChangePayperiod={onChangePayperiod}
                                   data={factorData}/>
          })
        }
        {/*<PayperiodTable/>*/}
      </div>
    </div>
  )
}
/** ============================================================================
 * 单条-缴费年期tabale（缴费年期、推广费分配、首年、第二年。。。）
 * @param props
 * @returns {*}
 * @constructor
 */
export const PayperiodTable = props => {
  const {data, payperiodKey, onChangePayperiod,isTop} = props
  const {isEdit, rateType, isFromRepository,productType} = useContext(TableContext)
  /**
   * @param assignKey 分配方式【当前机构，团队，业务员】
   * @param year 第几年
   * @param val 修改数值
   */
  const changeNum = (assignKey, year, val) => {
    const payData = deepCopy(data) // 缴费年期数据
    let _surplusVal = null
    if (rateType === 1 || rateType === 2) { // 1机构, 4团队
      // 剩余 = 可支配 - 当前机构
      payData.letout[year] = val + ''
    //   _surplusVal = ((payData.receivable[year] || 0) * 100 - val * 100) / 100 + ''
      _surplusVal = new Decimal(payData.receivable[year] || 0).sub(new Decimal(val)).toNumber().toFixed(2);
    } else { //2 团队配费
      // 剩余 = 可支配 - 团队长 - 业务员
      payData[assignKey][year] = val + ''
      !payData.group[year] && (payData.group[year] = 0)
      !payData.agency[year] && (payData.agency[year] = 0)
      const _groupFee = payData.group[year] || 0;
      const _agencyFee = payData.agency[year] || 0;
      _surplusVal = new Decimal(payData.receivable[year] || 0).sub(new Decimal(_groupFee)).sub(new Decimal(_agencyFee)).toNumber().toFixed(2);
    //   _surplusVal = ((payData.receivable[year] || 0) * 100 - (_groupFee * 100) -( _agencyFee * 100)) / 100 + ''
    }
    //  isTop 是否让第二年奖励的可支配和首年的剩余联动
    // 为 true 说明当前模板是一级机构模板/顶级机构的直属团队模板，这时调整推广费的第二年续期奖励需要取首年的剩余
    // String(productType) !== '2000' 不是短险才可以联动
    if (year === 'firstRate' && isTop && String(productType) !== '2000'){
      // * 1.首年的剩余 为第二年奖励的可支配
      payData.receivable.secondRenewalRewardRate = _surplusVal
      // * 2.计算第二年奖励的剩余
      let tempVal = 0
      if (rateType === 1 || rateType === 2) { // 1机构, 4团队
         // 剩余 = 可支配 - 当前机构
         tempVal = new Decimal(payData.receivable.secondRenewalRewardRate || 0).sub(new Decimal(payData.letout.secondRenewalRewardRate || 0)).toNumber().toFixed(2)
        // tempVal = ((payData.receivable.secondRenewalRewardRate || 0) * 100 - (payData.letout.secondRenewalRewardRate || 0) * 100) / 100 + ''
      } else {//2 团队配费
        // 剩余 = 可支配 - 团队长 - 业务员
        const _groupFee = payData.group.secondRenewalRewardRate || 0
        const _agencyFee = payData.agency.secondRenewalRewardRate || 0
        // tempVal = (((_surplusVal || 0) * 100) - (_groupFee * 100) - (_agencyFee * 100)) / 100 + ''
        _surplusVal = new Decimal(_surplusVal || 0).sub(new Decimal(_groupFee)).sub(new Decimal(_agencyFee)).toNumber().toFixed(2);
      }
      payData.surplus.secondRenewalRewardRate = tempVal
    }
    payData.surplus[year] = _surplusVal === 'NaN' ? '' : _surplusVal;
    onChangePayperiod(payperiodKey, payData)
  }

  return (
    <div className='tree-table'>
      <div className="payperiod-col">{props.data.payPeriodDesc || '-'}</div>
      <div className="branch-box">
        {
          (rateType === 1 || rateType === 2) ? (
            <div>
              <FeeTable title="可支配"
                        assignKey="receivable"
                        data={data.receivable}
                        isFromRepository={isFromRepository}
              />
              {
                !isFromRepository && // 产品库产品详情，取receivable，并且不展示推广费分配列
                <FeeTable title="当前机构"
                          assignKey="letout"
                          data={data.letout}
                          isEdit={isEdit}
                          editAppend={data.receivable}
                          changeNum={changeNum}
                          isFromRepository={isFromRepository}
                />
              }
              {
                !isFromRepository &&
                <FeeTable title="剩余"
                          assignKey="surplus"
                          data={data.surplus}
                />
              }
            </div>
          ) : (
            <div>
              <FeeTable title="可支配"
                        assignKey="receivable"
                        data={data.receivable}
              />
              <FeeTable title="团队长"
                        assignKey="group"
                        data={data.group}
                        isEdit={isEdit}
                        editAppend={data.receivable}
                        changeNum={changeNum}
              />
              <FeeTable title="业务员"
                        assignKey="agency"
                        data={data.agency}
                        isEdit={isEdit}
                        editAppend={data.receivable}
                        changeNum={changeNum}
              />
              <FeeTable title="剩余"
                        assignKey="surplus"
                        data={data.surplus}
              />
            </div>
          )
        }
        {/*<FeeTable/>*/}
      </div>
    </div>
  )

}
/** ============================================================================
 * 单条-推广费分配table (推广费分配、首年、第二年。。。)
 * @param props
 * @returns {*}
 * @constructor
 */
export const FeeTable = props => {
  const {hasActive, isShortInsClass, productType} = useContext(TableContext)
  const {
    title,
    assignKey,
    isEdit = false,
    editAppend = {},
    changeNum = null,
    data
  } = props
  console.log(props);
  const {json} = useParams()
    const jsonstr = decodeURIComponent(json)
    const spuId = getValueFromJsonStr(jsonstr, 'spuId')
  if(!props.data)return <div></div>
  const { pathname } = useLocation()
  //是不是模板页面
  const isTemplate =  pathname.startsWith('/feeTemplate/detail') || pathname.startsWith('/commission/template');
  const isProductPage =  pathname.startsWith('/productRepository/detail');//是不是产品详情页
  const {firstRate='', firstBackRate='', secondRate='', thirdRate='', fourthRate='', fifthRate='', firstActivityRate='', secondRenewalRewardRate='', sixthRate='',
            seventhRate='',
            eighthRate='',
            ninthRate='',
            tenthRate='',
            eleventhRate='',
            twelfthRate='',
            thirteenthRate='',
            fourteenthRate='',
            fifteenthRate='',
            sixteenthRate='',
            seventeenthRate='',
            eighteenthRate='',
            nineteenthRate='',
            twentiethRate=''} = data // 首年活动
  // useMemo()
  const feeYear = hasActive ?
    [
      {firstRate},
      {firstActivityRate}
    ] : [
      {firstRate}
    ]

    if (isTemplate) {
        //是模板页追加首年后置费用
        feeYear.push( {firstBackRate},{secondRate});
    }else{
        //不是模板页面 长险追加首年后置给用
        if (String(productType) !== '2000') {
            feeYear.push( {firstBackRate});
        }
        //不是产品页详情或者是短险追加第二年 原逻辑
        // if (!isProductPage||String(productType) === '2000') {
        //     feeYear.push( {secondRate});
        // }
        feeYear.push( {secondRate});
    }
    // feeYear.push( {firstBackRate},{secondRate});
    let reset = []

    // 不是产品库详情页
    if(!pathname.startsWith('/productRepository/detail')){
      // 是推广费产品详情页  并且不是短险
      if(pathname.startsWith('/feeTemplate/detail/product') && String(productType) !== '2000'){
        reset.push({secondRenewalRewardRate})
      }else if(!pathname.startsWith('/feeTemplate/detail/product') && pathname.startsWith('/feeTemplate/detail/'))  {
      // 是推广费详情页
        reset.push({secondRenewalRewardRate})
      }else if(pathname.startsWith('/commission/template/')){
        //  单独配费的模板页面
        reset.push({secondRenewalRewardRate})
      }else if(String(productType) !== '2000'){
        //  不是短险 （如：单独配费产品详情页）
        reset.push({secondRenewalRewardRate})

      }
    }
  if(!isShortInsClass){ // 取消长短险限制
    // let reset = productType==='1000'?
    //   [{thirdRate},{fourthRate},{fifthRate}]:
    //   [{thirdRate: ''}, {fourthRate: ''}, {fifthRate: ''}] //短险状态下，后端可能会返回345年的数据0；前端掐掉； @liuYaBin
    reset = reset.concat([{thirdRate},{fourthRate},{fifthRate},{sixthRate},{seventhRate},{eighthRate},{ninthRate},{tenthRate},{eleventhRate},{twelfthRate},{thirteenthRate},{fourteenthRate},{fifteenthRate},
            {sixteenthRate},
            {seventeenthRate},
            {eighteenthRate},
            {nineteenthRate},
            {twentiethRate}])
    //模板页或者长险产品追加第六年+数据
    // if (isTemplate||String(productType) !== '2000') {
    //     console.log('sixthRate是否追加第6年---', sixthRate);
    //     //是模板页或者是长险追加首年后置费用
    //     reset.push({sixthRate});
    // }
    if(!hideFreeSpuIds.includes(spuId)){
        feeYear.push(...reset)
    }
  }

  return (
    <div className='tree-table fee-row'>
      {
        !props.isFromRepository &&
        <div className="assign-col">{title}</div>
      }
      {
        feeYear.map((td, index) => {
          const KEY = Object.keys(td)[0] // 'firstRate', 'secondRate'
          const VALUE = Object.values(td)[0] // firstRate, secondRate
          let edit;
          if (isEdit) {
            // 如果是第二年奖励 并且不是短险的 就一直可编辑
            if (KEY === 'secondRenewalRewardRate') {
              edit = String(productType) !== '2000' && true
            }else{
              // 其他情况需要上级机构费>0可编辑
              edit = editAppend[KEY] * 1 > 0 // 上级机构费>0可编辑
            }
          }
          return (
            <div key={index} style={ KEY === 'secondRenewalRewardRate' ? { minWidth: '100px' } : null} className={`fee-td ${(assignKey === 'surplus' && VALUE * 1 < 0) ? 'red' : ''}`}>
              <EditNumber changeNum={changeNum}
                          valKey={KEY}
                          productType={productType}
                          option={{
                            assignKey,
                            key: KEY,
                            val: VALUE,
                            isEdit: edit
                          }}
              />
            </div>
          )
        })
      }
    </div>
  )
}
/** ======================
 * 数值编辑组件
 * @param props
 * @returns {*}
 * @constructor
 */
const EditNumber = props => {
  const {assignKey, key, val, isEdit} = props.option
  const { valKey, productType} = props
  const [isChange, setIsChange] = useState(false)

  useEffect(()=>{
    !isEdit && setIsChange(false) // 重置编辑高亮状态
  },[isEdit])

  const changeNum = v => {
    v = v === null ? 0 : v;
    props.changeNum(assignKey, key, v)
    setIsChange(true)
  }
  const limitDecimals = (value) => {
    const reg = /^(\-)*(\d+)\.(\d\d).*$/
    if (typeof value === 'string') {
      return !isNaN(Number(value)) ? value.replace(reg, '$1$2.$3') : ''
    } else if (typeof value === 'number') {
      return !isNaN(value) ? String(value).replace(reg, '$1$2.$3') : ''
    } else {
      return ''
    }
  }
  const memoNum = useMemo(() =>{
    if(val === undefined || Number(val) === 0){
      return '-'
    }
    Number(val).toFixed(2)
    const dec = String(val).split('.')[1]
    let result = null;
    if(dec && dec.length>2){
      result = toCutNum(val,2)
    }else{
      result = Number(val).toFixed(2)
    }
    return result * 1
  }, [val])

  return (
    <div>
      {
        isEdit ? (
          <InputNumber className={`tempfee-input-num ${isChange && 'isChange'}`}
                       min={0}
                       max={999}
                       precision={2}
                       defaultValue={val || 0}
                       value={val || 0}
                       onChange={changeNum}
                       formatter={limitDecimals}
                       parser={limitDecimals}
          />
          // 如果是第二年奖励 并且是短险 显示‘-’ 否则照常展示数据
        ) : (valKey === 'secondRenewalRewardRate' && String(productType) === '2000') ? '-' : memoNum
      }
    </div>
  )
}
